import React from 'react';

const iconBaseProps = {
  viewBox: '0 0 24 24',
  fill: 'none',
  'aria-hidden': true,
  focusable: false,
};

function IconWrap({ children, size = 18, className = 'settings-menu-icon-svg' }) {
  return (
    <svg {...iconBaseProps} width={size} height={size} className={className}>
      <g
        stroke="currentColor"
        strokeWidth="1.65"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        {children}
      </g>
    </svg>
  );
}

export function SettingsAccountIcon(props) {
  return (
    <IconWrap {...props}>
      <circle cx="12" cy="8" r="3.25" />
      <path d="M5.25 20v-.5A6.75 6.75 0 0 1 12 12.75h0a6.75 6.75 0 0 1 6.75 6.75v.5" />
    </IconWrap>
  );
}

export function SettingsPrivacyIcon(props) {
  return (
    <IconWrap {...props}>
      <rect x="6.5" y="10.5" width="11" height="9.5" rx="2.1" />
      <path d="M8.5 10.5V8.9a3.5 3.5 0 0 1 7 0v1.6" />
      <circle cx="12" cy="15.4" r="1.2" />
    </IconWrap>
  );
}

export function SettingsNotificationIcon(props) {
  return (
    <IconWrap {...props}>
      <path d="M18 9.75a6 6 0 1 0-12 0c0 4.4-1.5 5.6-1.5 5.6h15s-1.5-1.2-1.5-5.6Z" />
      <path d="M10.25 18.2a1.9 1.9 0 0 0 3.5 0" />
    </IconWrap>
  );
}

export function SettingsBillingIcon(props) {
  return (
    <IconWrap {...props}>
      <rect x="3.75" y="6.25" width="16.5" height="11.5" rx="2.25" />
      <path d="M3.75 10h16.5" />
      <path d="M7.5 14.2h3.4" />
      <path d="M14 14.2h2.5" />
    </IconWrap>
  );
}

export function SettingsAppearanceIcon(props) {
  return (
    <IconWrap {...props}>
      <circle cx="12" cy="12" r="6.25" />
      <path d="M12 5.75v12.5" />
      <path d="M5.75 12H18.25" />
    </IconWrap>
  );
}

export function SettingsAboutIcon(props) {
  return (
    <IconWrap {...props}>
      <circle cx="12" cy="12" r="8" />
      <path d="M12 10.25v5" />
      <path d="M12 7.5h.01" />
    </IconWrap>
  );
}

export function SettingsHelpIcon(props) {
  return (
    <IconWrap {...props}>
      <path d="M9.9 9a2.35 2.35 0 1 1 3.75 1.9c-.9.66-1.4 1.13-1.4 2.1" />
      <path d="M12.2 17h.01" />
      <circle cx="12" cy="12" r="8" />
    </IconWrap>
  );
}

export function SettingsLogoutIcon(props) {
  return (
    <IconWrap {...props}>
      <path d="M9.25 4.75h-2A2.25 2.25 0 0 0 5 7v10a2.25 2.25 0 0 0 2.25 2.25h2" />
      <path d="M13.5 15.5 17 12l-3.5-3.5" />
      <path d="M10.25 12H17" />
    </IconWrap>
  );
}
